import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DroitSimulationModel } from '../models/droitsimulation.model';
import { of, lastValueFrom } from 'rxjs';
import { FoyerModel } from '../models/calcul/foyer.model';
import { ConstanteUri } from '../../constants/constante-uri';
import { DeclarationModel } from '../../01-declaration/models/declaration.model';


@Injectable({ providedIn: 'root' })

/**
 * Service de coordination permettant de simuler un examen du montant du droit d'aide au logement . 
 * Il fait appel au service calculsprestationmiddle en lui transmettant les éléments reçu de l'usager.
 */
export class SimulerPrestationService {

  // Le content type du header
  private readonly contentType = 'Content-Type';
  // La valeur du content type du header
  private readonly contentTypeValue = 'application/json';

  headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');

  public droitSimulationModel: DroitSimulationModel;

  /**
* Constructeur du service app main du projet Drappli
* @param http Permet de faire des appels Http
* @param router Permet de faire des appels vers des ressources définit dans le app-routing.module
*/
  constructor(private readonly http: HttpClient) {
    this.droitSimulationModel = new DroitSimulationModel();
  }

  /**
 * Suppression de la saisie enregistrée dans la démarche DRA + MAJ du flux utilisé coté IHM : 
 * 
 * - Appel synchrone du servicrestationalmiddle pour le traitement de la simulation
 * 
 * Redirige vers la page d'incident si erreur à l'appel du service
 * 
 * @param foyerBody id de la démarche à modifier
 *  @returns DroitSimulationModel
 */
  public async simuler(body: FoyerModel): Promise<DroitSimulationModel> {
    
    if (environment.bouchon) {
      this.droitSimulationModel = new DroitSimulationModel();
      sessionStorage.setItem("erreurSimulateur", "");

      this.droitSimulationModel.possedeDesDroits = true;
      this.droitSimulationModel.montantDroit = 230;
      return lastValueFrom(of(this.droitSimulationModel));
    }

    try {      
      sessionStorage.setItem("erreurSimulateur", "false");
      this.droitSimulationModel = await lastValueFrom(this.http.post<DroitSimulationModel>(
        ConstanteUri.URI_CALCUL, JSON.stringify(body), { headers: this.headers }        
      ));
    }
    catch (err) {
      sessionStorage.setItem("erreurSimulateur", "true");

      console.log('erreur lors de l appel calcul service prestationalmiddle: ');
      console.log('JSON.stringify(body)', JSON.stringify(body));      
    }
    
    return this.droitSimulationModel;
  }

  /**
   * retour du service de calcul DroitSimulationModel
   * @returns DroitSimulationModel droit en sortie
   */
  getDroit(): DroitSimulationModel {
    return this.droitSimulationModel;
  }

  /**
   * Récupère unflux bouchon pour simuler une saisie IHM 
   * @returns DeclarationModel flux en sortie
   */
  getDeclarationModelJSON(): Promise<DeclarationModel> {

    const url = ConstanteUri.URL_CALCUL_USAGER_MODEL_BOUCHON;

    return lastValueFrom(this.http.get<DeclarationModel>(url));
  }
}
